export enum TASK_EVENT_TYPE {
  POST_EXAM_SCHEDULE = 'AEX',
  POST_CONSULTATION_SCHEDULE = 'ACO',
  POST_SURGERY_SCHEDULE = 'ACI',
  GOING_TO_PROMPT_SERVICE = 'IPA',
  POST_CONSULTATION_SCHEDULE_EXEC = 'EAC',
  POST_EXAM_SCHEDULE_EXEC = 'EAE',
  POST_SURGERY_SCHEDULE_EXEC = 'EAG',
  POST_PATIENT_DISCHARGE = 'EAP',
  POST_SERVICE_SCHEDULE_EXEC = 'EAS',
  POST_SERVICE_SCHEDULE = 'ASE',
}
